import { AutocompleteSearch } from 'js/core_post_webpack/sitewide_business_elements/navbar/autocomplete_search';
import routes from 'js/core_pre_webpack/routes';
import {
  LoginModal,
  Props as LoginModalProps,
} from 'js/login_modal/LoginModal';
import {
  setUpThirdPartySignIn,
  appleAsyncLoad,
} from 'js/login_modal/setUpThirdPartySignIn';
import {
  PartialConfigurableText,
  RegistrationParams,
} from 'js/login_modal/types';
import {
  trackClick,
  Options as ClickTrackingOptions,
} from 'js/utils/trackClick';
import { createElement } from 'react';
import ReactDOM from 'react-dom';

export type Props = {
  pageName: string;
  clickTrackingContext?: Partial<ClickTrackingOptions>;
  loginModalText?: PartialConfigurableText;
  registrationParams?: RegistrationParams;
  postLoginRedirectUrl?: string;
  forcePostLoginRedirectUrl?: boolean;
};

/**
 * Run this function in your page's webpack bundle to connect the signup and
 * login buttons in the header bar to the login modal. You'll also need to modify
 * app/views/layouts/simple/header/_login_buttons.html.slim according to the instructions
 * listed in that file.
 *
 * @param props data to be passed to the login modal. pageName is required for click tracking.
 */
export const setUpLoginButtons = ({
  pageName,
  clickTrackingContext,
  loginModalText,
  registrationParams,
  postLoginRedirectUrl,
  forcePostLoginRedirectUrl,
}: Props) => {
  const loginButtons = document.querySelectorAll('.react-login-modal-opener');
  // Used to block Google and FB requests when the user is in geo-blocked regions such as China
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const userInChina = (window as any).userInChina === 'true';

  if (userInChina) {
    appleAsyncLoad();
  } else {
    // Google, Facebook, Apple
    setUpThirdPartySignIn();
  }

  const reactRootElement = document.getElementById('react-modal');
  const modalId = 'react-login-modal';

  const baseRegistrationParams: RegistrationParams = {
    user_source: 'download',
  };

  const loginModalProps: LoginModalProps = {
    id: modalId,
    clickTrackingContext,
    configuredText: loginModalText,
    registrationParams: { ...baseRegistrationParams, ...registrationParams },
    postLoginRedirectUrl,
    forcePostLoginRedirectUrl,
  };

  ReactDOM.render(createElement(LoginModal, loginModalProps), reactRootElement);

  const dialogElement = document.getElementById(modalId) as HTMLDialogElement;
  loginButtons.forEach((elem) => {
    elem.addEventListener('click', (e) => {
      e.preventDefault();

      const data = JSON.parse(elem.getAttribute('data-signup-modal') as string);
      trackClick({
        source: `${pageName}--${data.location}`,
        ...clickTrackingContext,
      });

      dialogElement.showModal();
    });
  });
};

export const setUpMobileHamburgerMenu = () => {
  const headerDropdownMoreButton = document.querySelector(
    '.js-header-dropdown-expand-button',
  );
  const headerDropdownLessButton = document.querySelector(
    '.js-header-dropdown-collapse-button',
  );
  const headerHamburgerButton = document.querySelector(
    '.js-header-hamburger-button',
  );
  const headerDropdown = document.querySelector('.js-header-dropdown');

  headerHamburgerButton?.addEventListener('click', (ev) => {
    ev.preventDefault();
    headerDropdown?.classList.toggle('expanded');
  });
  headerDropdownMoreButton?.addEventListener('click', (ev) => {
    ev.preventDefault();
    headerDropdownMoreButton.classList.toggle('hide');
    headerDropdown?.classList.toggle('fully-expanded');
  });
  headerDropdownLessButton?.addEventListener('click', (ev) => {
    ev.preventDefault();
    headerDropdownMoreButton?.classList.toggle('hide');
    headerDropdown?.classList.toggle('fully-expanded');
  });

  // TODO: This should be set without js
  const loginUrl = routes.login_url({
    post_login_redirect_url: encodeURIComponent(window.location.href),
  });
  document
    .querySelector('.js-header-login-url')
    ?.setAttribute('href', loginUrl);

  new AutocompleteSearch({
    el: '.js-SiteSearch-form',
  });
};
